import React, { FC } from 'react';
import { Main } from './components/main';

export const OsSimulator: FC = () => <Main />;
